import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries } from "@/api/http-common";

export function callApiTaoNhomCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}`,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaNhomCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.UPDATE}`,
    method: "POST",
    data: payload,
  });
}

export function callApiCopyNhomCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.COPY}${payload}`,
    method: "POST",
  });
}

export function callApiXoaNhomCongViec(id) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}?id=${id}`,
    method: "DELETE",
  });
}

export function callApiLayNhomCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.SEARCH}`,
    method: "POST",
    data: payload,
  });
}

export function callApiLayChiTietNhomCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.CHI_TIET}`,
    method: "POST",
    data: payload,
  });
}

export function callApiXoaDonViCaNhanTrongNhom(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.XOA_DON_VI_CA_NHAN}`,
    method: "POST",
    data: payload,
  });
}

export function callApiThemDonViCaNhan(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.NAME}${ENDPOINT.QUAN_TRI_HE_THONG.NHOM_LAM_VIEC.THEM_DON_VI_CA_NHAN}`,
    method: "POST",
    data: payload,
  });
}

export function callApiSearchCauHinh(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.CAU_HINH.SEARCH,
    method: "POST",
    data: payload,
  });
}

export function callApiUpdateCauHinh(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.CAU_HINH.UPDATE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}
export function callApiGetDanhSachDeMuc(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.GET_DANH_SACH_DE_MUC}?nam=${payload.nam}`,
    method: "GET",
    params : payload,
  })
 }

 export function callApiGetDongBoDanhMucChung(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.CAU_HINH.DONG_BO_CHUNG ,
    method: "GET",
    params : payload,
  })
 }

 export function callApiDongBoCanBo(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.CAU_HINH.DONG_BO_CAN_BO}`,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaDeMuc(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.SUA_DE_MUC}?nam=${payload.Nam}`,
    method: "PUT",
    data: payload,
  });
 }
 export function callApiGetListYearFilterLinhVuc(payload){
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.GET_LIST_YEAR_FILTER,
    method: "GET",
    params: payload,
  });
 }
export function callApiGetDanhSachLinhVuc(payload){
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.GET_DANH_SACH_LINH_VUC}`,
    method: "POST",
    data:payload
  });
}
export function callApiGetChiTietLinhVuc(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.CHI_TIET_LINH_VUC}?id=${payload}`,
    method: "GET",
    params : payload
  });
}

export function callApiGetCurrentPhongBan(payload) {
  return HTTP({
    url:ENDPOINT.QUAN_TRI_HE_THONG.GET_BY_CURRENT_PHONG_BAN,
    method: "GET",
    data: payload,
  })
}

export function callApiGetLinhVucDonVi(payload){
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.GET_BY_LINH_VUC_DON_VI,
    method: "GET",
    data: payload,
  });
}


export function callApiThemLinhVuc(payload){
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.THEM_MOI_LINH_VUC,
    method: "POST",
    data: payload,
  });
}
export function callApiXoaLinhVuc(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.XOA_LINH_VUC,
    method: "DELETE",
    data: payload,
  });
}
export function callApiXoaMultiLinhVuc(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.XOA_MULTI_LINH_VUC,
    method: "DELETE",
    data: payload
  })
}
export function callApiListPhongBan(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.LIST_PHONG_BAN}?id=${payload}`,
    method: "GET",
    params: payload,
  })
}
 
export function callApiSuaLinhVuc(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.SUA_LINH_VUC}`,
    method: "PUT",
    data: payload,
  });
}

export function callApiGetDanhSachNopLuu(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.SEARCH_TREE,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDonViNhan(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.GET_DON_VI_NHAN,
    method: "GET",
    data: payload,
  });
}

export function callApiGetDonViGui(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.GET_DON_VI_GUI}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiAddDonViGui(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.THEM,
    method: "POST",
    data: payload,
  });
}

export function callApiXoaDonViGui(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.XOA_DON_VI_GUI}`,
    method: "DELETE",
    data: payload,
  });
}

export function callApiGetHasDaiDienBo(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.DON_VI_NOP_LUU.HAS_DAI_DIEN_BO,
    method: "GET",
    data: payload,
  });
}
// Cấu hình ủy quyền
export function callApiGetDanhSachCauHinhUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.DS_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiThayDoiUyQuyen(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.THAY_DOI_UY_QUYEN,
    method: "POST",
    data: payload,
  });
}

export function callApiGetNguoiUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.GET_NGUOI_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
}

export function callApiGetDonViUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.GET_DON_VI_UY_QUYEN}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
}

export function callApiGetNguoiDuocUyQuyen(params) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.GET_NGUOI_DUOC_UY_QUYEN(params.idNguoiUyQuyen)}`,
    method: "GET",
    params: params,
  })
}

export function callApiGetNguoiTaoHo(params) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.GET_NGUOI_TAO_HO(params.idNguoiUyQuyen)}`,
    method: "GET",
    params: params,
  })
}

export function callApiThemNguoiUyQuyen(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.THEM_UY_QUYEN,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaNguoiUyQuyen(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.SUA_UY_QUYEN,
    method: "PUT",
    data: payload,
  });
}

export function callApiXoaNguoiUyQuyen(params) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.XOA_UY_QUYEN(params.Id)}`,
    method: "DELETE",
    data: params,
  })
}

export function callApiGetDanhSachViTriUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.VI_TRI_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// Quản lý ủy quyền
export function callApiGetDanhSachQuanLyUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.DS_QL_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachDuocUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.DS_DUOC_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachUyQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.QUAN_TRI_HE_THONG.DS_GET_UY_QUYEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
}

export function callApiGetQuanLyNguoiUyQuyen(params) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.DS_GET_DUOC_UY_QUYEN(params.idNguoiUyQuyen)}`,
    method: "GET",
    params: params,
  })
}

export function callApiThemQuanLyUyQuyen(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.THEM_QL_UY_QUYEN,
    method: "POST",
    data: payload,
  });
}

export function callApiSuaQuanLyUyQuyen(payload) {
  return HTTP({
    url: ENDPOINT.QUAN_TRI_HE_THONG.SUA_QL_UY_QUYEN,
    method: "PUT",
    data: payload,
  });
}

export function callApiXoaQuanLyUyQuyen(payload) {
  return HTTP({
    url: `${ENDPOINT.QUAN_TRI_HE_THONG.XOA_QL_UY_QUYEN(payload.Id)}`,
    method: "DELETE",
    data: payload,
  })
}


